export default "__VITE_ASSET__CZh2xhxd__"